import React, { useState, useEffect, useRef } from "react";
import jQuery from "jquery";

import OkCountdown from "./OkCountdown";
import TextCountdownTimer from "./TextCountdownTimer";
import OkcApi from "shared/util/OkcApi";
import Bounce20 from "./Bounce20";

// Supported Promo Types.
const PROMO_TYPE = {
	Bounce20: "bounce20",
};

// Map Promo Types to Components.
const PROMO = {
	[PROMO_TYPE.Bounce20]: Bounce20,
};

const Promos = React.forwardRef((_, ref) => {
	// Fetch the going discount.
	// We've been assured there is one, but don't trust anybody.
	const [discount, setDiscount] = useState(null);
	useEffect(() => {
		OkcApi.get("billingws/discount")
			.then((res) => setDiscount(res.discount));
	}, []);


	// Check if this is a discount we can handle.
	const noDiscount = !discount || !discount.id || !PROMO[discount.id];

	// Initialize some timers. These are legacy jQuery libs.
	// Probably should be rewritten into React... someday.
	const countdownClock = useRef(null);
	const textTimer = useRef(null);
	useEffect(() => {
		if (noDiscount) return;

		// Convert to seconds, because that's somehow our unit.
		const now = Math.round(Date.now() / 1000);
		const defaultDeadline = (now + 60 * 60 * 6 - 30); // This should only be needed for staff.
		const deadline = discount.expires || defaultDeadline;

		// Init OkCountdown.
		if (countdownClock.current) {
			new OkCountdown({
				container: jQuery(countdownClock.current),
				deadline,
				now,
			});
		}

		// Init TextCountdown.
		if (textTimer.current) {
			new TextCountdownTimer(
				textTimer.current,
				deadline - now,
			);
		}
	}, [discount, noDiscount]);

	// Exit if we can't find this promo.
	if (noDiscount) {
		return null;
	}

	// Find and render the appropriate promo.
	const Promo = PROMO[discount.id];
	const promoProps = {
		countdownClock,
		textTimer,
	};

	return (
		<Promo ref={ref} {...promoProps} />
	);
});

export default Promos;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/Promos/index.jsx